module.exports = __webpack_public_path__ + "img/live_icon.992f79b6.png";